
<mat-card
    class="daxa-card recent-orders-card mb-25 border-radius bg-white border-none d-block"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <mat-card-header>
        <mat-card-title>
            <form class="search-box position-relative">
                <i class="material-symbols-outlined">
                    search
                </i>
                <input type="text" class="input-search d-block w-100 border-none outline-0 rounded-pill"
                       placeholder="Chercher une analyse..."
                       (keyup)="applyFilter($event)" #input>
            </form>
        </mat-card-title>
        <mat-card-subtitle>
            <button type="button" class="btn btn-primary btn-sm rounded-pill border-0 me-3 position-relative"
                    (click)="calculerMultipleResult()">
                <span class="px-2">Calculer</span>
                <span *ngIf="editedItems.size"
                      class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                    {{ editedItems.size }}
                  </span>
            </button>
            <button class="btn btn-primary btn-sm rounded-pill border-0" (click)="openImportModal(importModal)">
                <span class="px-2">Importer Résultats</span>
            </button>
        
        </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <div class="recent-orders-table">

            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort >

                    <!-- select Column -->
                    <ng-container matColumnDef="select">
                        <th mat-header-cell
                            *matHeaderCellDef>
                            <mat-checkbox (change)="handleSelectAll()"/>
                        </th>
                        <td mat-cell *matCellDef="let element" style="padding: 20px">
                            <mat-checkbox [checked]="selectedAll" (change)="handleChecked(element)"/>
                        </td>
                    </ng-container>

                    <!-- sampleCode Column -->
                    <ng-container matColumnDef="ref">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Réference</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <input
                                class="form-control border-0" readonly
                                type="text"
                                [value]="element.refAnalyse"
                                (keydown)="navigateInputs($event, i, 'ref')"
                                [id]="'ref' + i"
                            ></td>
                    </ng-container>

                    <!-- sampleCode Column -->
                    <ng-container matColumnDef="sampleCode">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Échantillion</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <input
                                class="form-control border-0" readonly
                                type="text"
                                [value]="element.sampleCode"
                                (keydown)="navigateInputs($event, i, 'sampleCode')"
                                [id]="'sampleCode' + i"
                            ></td>
                    </ng-container>
                    <!--<ng-container matColumnDef="formule">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Formule</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <input
                                class="form-control border-0" readonly
                                type="text"
                                [value]="element.formuleName"
                                (keydown)="navigateInputs($event, i, 'formule')"
                                [id]="'formule' + i"
                            ></td>
                    </ng-container> -->
                    <!-- parameter Column -->
                    <ng-container matColumnDef="parameter">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Parametre</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <input
                                class="form-control border-0" readonly
                                type="text"
                                [value]="element.parameterName"
                                (keydown)="navigateInputs($event, i, 'parameter')"
                                [id]="'parameter' + i"
                            ></td>
                    </ng-container>

 

                    <!-- startDate Column -->
                    <ng-container matColumnDef="startDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date début</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <input readonly
                                class="form-control border-0"
                                type="datetime-local"
                                [(ngModel)]="element.startDate"
                                (keydown)="navigateInputs($event, i, 'startDate')"
                                [id]="'startDate' + i"
                            ></td>
                    </ng-container>
                    <ng-container matColumnDef="lq">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>LQ</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <input readonly
                                class="form-control border-0"
                                type="num"
                                [(ngModel)]="element.lq"
                                (keydown)="navigateInputs($event, i, 'lq')"
                                [id]="'lq' + i"
                            ></td>
                    </ng-container>
                    <!-- endDate Column -->
                    <ng-container matColumnDef="endDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date fin</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <input
                                class="form-control border-0"
                                type="datetime-local"
                                [(ngModel)]="element.endDate"
                                (keydown)="navigateInputs($event, i, 'endDate')"
                                (change)="addResult(element)"
                                [id]="'endDate' + i"
                            ></td>
                    </ng-container>

                    <!--<ng-container matColumnDef="dateMesure">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date de mesure</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <input
                                class="form-control border-0"
                                type="datetime-local"
                                [(ngModel)]="element.dateMesure"
                                (keydown)="navigateInputs($event, i, 'dateMesure')"
                                (change)="addResult(element)"
                                [id]="'dateMesure' + i"
                            ></td>
                    </ng-container>-->

                    <!-- Poids Column -->
                    <ng-container matColumnDef="poids">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Poids</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <input
                                class="form-control border-0"
                                type="number"
                                [(ngModel)]="element.poids"
                                (keydown)="navigateInputs($event, i, 'poids')"
                                (change)="addResult(element)"
                                [id]="'poids' + i">
                        </td>
                    </ng-container>

                    <!-- Resultat Column 
                    <ng-container matColumnDef="resultatBrute">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Résultat brute</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <input
                                class="form-control border-0"
                                type="number"
                                [(ngModel)]="element.resultatBrute"
                                (keydown)="navigateInputs($event, i, 'resultatBrute')"
                                (change)="addResult(element)"
                                [id]="'resultatBrute' + i"
                            >
                        </td>
                    </ng-container>-->

                    <!-- Resultat Column -->
                    <ng-container matColumnDef="resultatFinale">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Resultat finale</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <input readonly
                                class="form-control border-0"
                                type="number"
                                [(ngModel)]="element.resultatFinale"
                                (keydown)="navigateInputs($event, i, 'resultatFinale')"
                                [id]="'resultatFinale' + i"
                            >
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="valide">
  <th mat-header-cell *matHeaderCellDef mat-sort-header>Validé</th>
  <td mat-cell *matCellDef="let element; let i = index">
    <select readonly
            class="form-control border-0"
            [(ngModel)]="element.valide"
            (keydown)="navigateInputs($event, i, 'valide')"
            [id]="'valide' + i">
      <option [value]="true">Oui</option>
      <option [value]="false">Non</option>
    </select>
  </td>
</ng-container>

                    <!-- commentaire Column -->
                    <ng-container matColumnDef="commentaire">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Commentaire</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <input
                                class="form-control border-0"
                                type="text"
                                [(ngModel)]="element.commentaire"
                                (keydown)="navigateInputs($event, i, 'commentaire')"
                                (change)="addResult(element)"
                                [id]="'commentaire' + i"
                            >
                        </td>
                    </ng-container>

                    <!-- Action Column -->
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="text-center"> Actions</th>
                        <td mat-cell *matCellDef="let element">
                            <div class="action-info text-center" style="justify-content: center !important;">
<!--                                <button type="button" mat-button matTooltip="Sauvegarder" matTooltipPosition="above"-->
<!--                                        (click)="updateAnalyse(element)">-->
<!--                                    <i class="material-symbols-outlined text-primary">-->
<!--                                        check_circle-->
<!--                                    </i>-->
<!--                                </button>-->
                                <button type="button" mat-button matTooltip="Visualiser" matTooltipPosition="above"
                                        (click)="openViewModel(element)">
                                    <i class="material-symbols-outlined text-primary">
                                        visibility
                                    </i>
                                </button>
                                <button type="button" mat-button matTooltip="Supprimer" matTooltipPosition="above"
                                        (click)="confirmDelete(element.id)">
                                    <i class="material-symbols-outlined text-danger">
                                        delete
                                    </i>
                                </button>
                            </div>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                    <tr class="mat-row" *matNoDataRow>
                        <td *ngIf="!loadingTable" class="mat-cell" colspan="15">Aucun Analyse trouvé pour Analyse</td>
                    </tr>

                </table >

                <div *ngIf="loadingTable">
                    <div *ngFor="let i of [].constructor(6)" class="skeleton-row">
                        <span class="skeleton-cell"></span>
                    </div>
                </div>
            </div>

            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
    </mat-card-content>
</mat-card>

<!-- Add modal template for nv
<ng-template #content let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
            <mat-card-title>
                <h5 class="my-0">
                    Affecter un utilisateur.
                </h5>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="form" (ngSubmit)="affectUser()">
                <mat-form-field class="mb-25">
                    <mat-label>Utilisateurs</mat-label>
                    <mat-select formControlName="userId">
                        <mat-option *ngFor="let user of userList" [value]="user.id">
                            {{ user.username }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="form.get('userId')?.hasError('required')">Champ obligatoire
                    </mat-error>
                </mat-form-field>
                <div class="col-sm-12 text-right">
                    <button type="submit" class="btn btn-outline-primary">Enregistrer</button>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</ng-template>
 -->

<!-- MODAL AFFECTATION UTILISATEUR -->
<ng-template #content let-modal>
    <div>
        <div class="modal-body">
            <form [formGroup]="form">
                <!-- Sélection de l'utilisateur -->
                <div class="form-group">
                    <h5 class="modal-title">Affecter un utilisateur</h5>
                    <select class="form-control" formControlName="userId">
                        <option *ngFor="let user of userList" [value]="user.id">{{ user.username }}</option>
                    </select>
                </div>
            </form>
        </div>
    </div>
</ng-template>


<!-- Add modal template for editing -->
<ng-template #editModal let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
            <mat-card-title>
                <h5 class="my-0">
                    Modifier Analyse
                </h5>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="editForm">
                <div class="row">

                    <!-- refAnalyse -->
                    <div class="col-sm-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Reference</mat-label>
                            <input readonly matInput formControlName="refAnalyse" placeholder="Ex. A12345">
                            <mat-error *ngIf="editForm.get('refAnalyse')?.hasError('required')">
                                Champ obligatoire!
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <!-- startDate -->
                    <div class="col-sm-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Start Date</mat-label>
                            <input matInput readonly [matDatepicker]="picker1" formControlName="startDate"
                                   placeholder="Select start date">
                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                            <mat-datepicker #picker1></mat-datepicker>
                            <mat-error *ngIf="editForm.get('startDate')?.hasError('required')">
                                Champ obligatoire!
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <!-- endDate -->
                    <div class="col-sm-4">
                        <mat-form-field class="mb-25">
                            <mat-label>End Date</mat-label>
                            <input matInput readonly [matDatepicker]="picker2" formControlName="endDate"
                                   placeholder="Select end date">
                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                            <mat-datepicker #picker2></mat-datepicker>
                            <mat-error *ngIf="editForm.get('endDate')?.hasError('required')">
                                Champ obligatoire!
                            </mat-error>
                        </mat-form-field>
                    </div>


                    <!-- Statut-->
                    <div class="col-sm-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Statut</mat-label>
                            <mat-select formControlName="status" placeholder="Select a client">
                                <mat-option [value]="0">En éxecusion</mat-option>
                                <mat-option [value]="1">Termié</mat-option>
                            </mat-select>
                            <mat-error *ngIf="editForm.get('status')?.hasError('required')">Champ obligatoire
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <!-- sample -->
                    <div class="col-sm-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Sample</mat-label>
                            <input matInput readonly formControlName="sampleCode">
                        </mat-form-field>
                    </div>

                    <!-- parameter -->
                    <div class="col-sm-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Parametre</mat-label>
                            <input matInput readonly formControlName="parameterName">
                        </mat-form-field>
                    </div>

                    <div class="col-sm-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Utilisateurs</mat-label>
                            <mat-select formControlName="userId" placeholder="Select a client">
                                <mat-option *ngFor="let user of userList" [value]="user.id">
                                    {{ user.username }}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="form.get('clientId')?.hasError('required')">Champ obligatoire
                            </mat-error>
                        </mat-form-field>
                    </div>


                    <!-- poids -->
                    <div class="col-sm-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Poids</mat-label>
                            <input type="number" matInput formControlName="poids">
                            <mat-error *ngIf="editForm.get('poids')?.hasError('required')">
                                Champ obligatoire!
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <!--                     resultat -->
                    <div class="col-sm-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Resultat
                            </mat-label>
                            <input type="number" matInput formControlName="resultat">
                            <mat-error *ngIf="editForm.get('resultat')?.hasError('required')">
                                Champ obligatoire!
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <!-- resultatFinale -->
                    <div class="col-sm-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Resultat finale</mat-label>
                            <input type="number" matInput formControlName="resultatFinale">
                            <mat-error *ngIf="editForm.get('resultatFinale')?.hasError('required')">
                                Champ obligatoire!
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <!-- commentaire -->
                    <div class="col-sm-8">
                        <mat-form-field class="mb-25">
                            <mat-label>Comment</mat-label>
                            <textarea matInput formControlName="commentaire" placeholder="Enter comment"></textarea>
                            <mat-error *ngIf="editForm.get('commentaire')?.hasError('required')">
                                Champ obligatoire!
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-sm-12 text-right">
                        <button type="submit" class="btn btn-outline-success">Enregister</button>
                    </div>

                </div>
            </form>
        </mat-card-content>
    </mat-card>
</ng-template>

<ng-template #viewModal let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-content>
            <div class="row">
                <h5 class="px-3 fw-bolder text-secondary">Détails analyse :</h5>

                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Nom du paramètre :</div>
                    <p>{{ analyse?.parameterName }}</p>
                </div>

                <!-- Analyse Reference -->
                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Référence Analyse :</div>
                    <p>{{ analyse?.refAnalyse }}</p>
                </div>

                <!-- Sample Details -->
                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Code Échantillon :</div>
                    <p>{{ analyse?.sampleCode }}</p>
                </div>

                <!-- Analysis Dates -->
                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Date de Début :</div>
                    <p>{{ analyse?.startDate | date : "short" }}</p>
                </div>

                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Date de Fin :</div>
                    <p>{{ analyse?.endDate | date : "short" }}</p>
                </div>

                <!-- Status -->
                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Statut :</div>
                    <p>{{ analyse?.status ? "Termié" : "En éxecusion" }}</p>
                </div>

                <!-- Creation and Update Dates -->
                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Créé le :</div>
                    <p>{{ analyse?.creationDate | date : "short" }}</p>
                </div>

                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Modifié le :</div>
                    <p>{{ analyse?.updateDate | date : "short" }}</p>
                </div>

                <!-- Created By -->
                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Créateur :</div>
                    <p>{{ analyse?.appUserName }}</p>
                </div>

                <!-- Poids -->
                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Poids :</div>
                    <p>{{ analyse?.poids }} Kg</p>
                </div>

                <!-- resultat -->
                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Resultat :</div>
                    <p>{{ analyse?.resultatBrute }}</p>
                </div>

                <!-- resultatFinale -->
                <div class="col-sm-6 col-lg-4 border-top p-3">
                    <div class="fw-bold">Resultat Finale :</div>
                    <p>{{ analyse?.resultatFinale }}</p>
                </div>


                <!-- Comment -->
                <div class="col-sm-6 col-lg-8 border-top p-3">
                    <div class="fw-bold">Commentaire :</div>
                    <p>{{ analyse?.commentaire }}</p>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</ng-template>

<ng-template #importModal>
  <mat-card class="daxa-card border-radius border-none d-block">
    <h4>Importer les résultats</h4>
    <div class="px-4 mt-5">
      <h5 class="mt-4">Depuis Excel</h5>

      <div class="row g-3 mb-3">
        <div class="col-lg-4">
          <label class="form-label fw-bold">Date de début</label>
          <input class="form-control" type="datetime-local" [(ngModel)]="importStartDate"/>
        </div>
        <div class="col-lg-4">
          <label class="form-label fw-bold">Date de fin</label>
          <input class="form-control" type="datetime-local" [(ngModel)]="importEndDate"/>
        </div>
        <div class="col-lg-4">
          <label class="form-label fw-bold">LQ</label>
          <input class="form-control" type="number" [(ngModel)]="importLQ"/>
        </div>
      </div>

      <!-- =================== Ligne 2: Date de mesure + Technique =================== -->
      <div class="row g-3 mb-3">
       <!-- <div class="col-lg-6">
          <label class="form-label fw-bold">Date de mesure</label>
          <input class="form-control" type="datetime-local" [(ngModel)]="importDateMesure"/>
        </div>-->
        <div class="col-lg-12">
          <label class="form-label fw-bold">Technique</label>
          <select class="form-select" [(ngModel)]="importTechnique">
            <option [ngValue]="null">-- Choisir --</option>
            <option value="LCMSMS">LC-MS/MS</option>
            <option value="GCMSMS">GC-MS/MS</option>
          </select>
        </div>
        
      </div>
<!-- =================== Liste des échantillons =================== -->
<div class="row g-3 mt-4">
  <div class="col-lg-12">
    <label class="form-label fw-bold">Échantillons en cours</label>

    <table class="table table-bordered table-striped">
      <thead>
        <tr>
          <th><input type="checkbox" [checked]="allSelected" (change)="toggleSelectAll($event)"/></th>
          <th>Code d'Echnatillon</th>
          <th>Poids Pur (g)</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let sample of inProgressSamples">
          <td>
            <input type="checkbox" [(ngModel)]="sample.selected"/>
          </td>
          <td>{{ sample.referenceInterne }}</td>
          <td>
            <input type="number" class="form-control form-control-sm"
                   [(ngModel)]="sample.poids"
                   placeholder="Entrez poids"/>
          </td>
        </tr>
      </tbody>
    </table>

  </div>
</div>

      <!-- =================== Ligne 3: Upload + Button =================== -->
      <div class="row g-3 align-items-end mb-2">
        <div class="col-lg-10">
          <label class="form-label fw-bold">Fichier Excel</label>
          <input class="form-control" type="file" (change)="ex_event = $event"
                 accept=".xlsx, .xls"/>
        </div>
        <div class="col-lg-2 text-end">
          <button [disabled]="!ex_event" class="btn btn-primary btn-sm rounded-pill px-4"
                  (click)="importExcel()">
            <i class="fa-solid fa-paper-plane me-2"></i>
          </button>
        </div>
      </div>

    </div>
  </mat-card>
</ng-template>

